export default __webpack_public_path__ + "static/media/bg-10.a05f0f18.jpg";